/**
 * Opinionated enumeration of common non-standard Gedcom tags.
 */
export var TagNonStandard;
(function (TagNonStandard) {
    TagNonStandard["CharacterAlt"] = "CHARACTER";
})(TagNonStandard || (TagNonStandard = {}));
//# sourceMappingURL=TagNonStandard.js.map